/**
 * Reason selection constants for wizard flows
 * Using const objects instead of enums for better extensibility
 */
// Shared reason selection options (used in both praise and feedback wizards)
export const SharedReasonOptions = {
    COLLABORATION_SERVICE: 'collaboration-service',
    SCHEDULE_AGREEMENT: 'schedule-agreement',
    COMMUNICATION: 'communication',
    INFORMATION_SHARING: 'information-sharing',
    PRAISE_FEEDBACK: 'praise-feedback',
};
// Praise-specific reason selection options
export const PraiseReasonOptions = {
    ...SharedReasonOptions,
    MEETING_EXPECTATIONS: 'meeting-expectations',
};
// Feedback-specific reason selection options
export const FeedbackReasonOptions = {
    ...SharedReasonOptions,
    EXPECTATIONS_SETTING: 'expectations-setting',
};
/**
 * Helper function to get the translation key for a reason option
 * Usage: `t(getReasonTranslationKey('collaboration-service'))` => `t('wizard:reasonConstants.collaboration-service')`
 */
export const getReasonTranslationKey = (reason) => {
    return `wizard:reasonConstants.${reason}`;
};
